import { Box, FormGroup, FormLabel, IconButton, Modal, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TitleText from './TitleText';

import CancelIcon from '@mui/icons-material/Cancel';
import ButtonStyled from './ButtonStyled';



const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {xs: '81.4%', md: '83.9%', lg: '62.5%'},
    bgcolor: 'background.paper',
    borderRadius: '0.25rem',
    boxShadow: 24,
    pt: '1.125rem',
    pb: '2.5rem',
    flexGrow: 1,
    '&:focus-visible': { outline: 0},
};

const formLabelStyle = {color: '#A1A1A1', fontWeight:'bold', fontSize:{xs: '1rem',}, display: 'flex', pb:'0.6rem' };
const inputStyle = {sx: { fontSize:{xs: '1rem', md: '1rem'}, whiteSpace: 'pre-line' }};

function SubcategoryNameModal({
    itemToEdit,
    openNameModal,
    onCloseNameNodal,
    onSubmitNameModal,
    isDisabled = false
}) {
    const [subcategoryForm, setSubcategoryForm] = useState({
        subCategoryName: "",
        description: ""
    })

    const { subCategoryName, description } = subcategoryForm

    useEffect(() => {
        if (!!itemToEdit) {
            setSubcategoryForm({...itemToEdit})
        }
    }, [itemToEdit])

    const onValueChange = (e) => {
        const newValue = e.target.value;
        const field = e.target.name;

        setSubcategoryForm(prev => ({
            ...prev,
            [field]: newValue
        }))
    }

    const handleSubmit = () => {
        onSubmitNameModal(subcategoryForm)
    }

    return (
        <Modal
            disableEscapeKeyDown
            slotProps={{backdrop: {onClick: null}}}
            open={openNameModal}
            onClose={onCloseNameNodal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
                backdropFilter: 'blur(2px)',
                BackdropProps:{
                onClick: null
                },
                '& .MuiModal-backdrop': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)'
                },
            }}
        >
            <Box sx={{maxHeight: "900px", width: "90%", overflowY: "scroll", ...styleModal}}>
                <Box sx={{display: 'flex', justifyContent: "flex-end", width:'100%', px: '1.25rem' }}>
                    <IconButton sx={{ padding: 0}} onClick={onCloseNameNodal}>
                        <CancelIcon sx={{color: '#FC581F', fontSize:'1.8rem'}}/>
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        p: 4,
                        gap: 4,
                        height: "100%"
                    }}  
                >
                    <Box sx={{ display:'flex', flexDirection: 'column', px: {xs: '1.25rem', md:'3.125rem'}, gap:'2.5rem' }}>
                        <TitleText title={"Nombre de Subcategoría"} customStyle={{ py: 0 }}/>
                    </Box>
                    <Box>
                        <FormGroup>
                            <FormLabel sx={{ fontSize: "22px" }} >Nombre</FormLabel>
                            <TextField 
                                sx={{ ...inputStyle }}
                                value={subCategoryName}
                                onChange={onValueChange}
                                name="subCategoryName"
                                onKeyDown={(e) => {
                                    // If enter is pressed, submit the form
                                    if (e.key === 'Enter') {
                                        handleSubmit();
                                    }
                                }}
                            />
                        </FormGroup>
                    </Box>
                    
                    <Box>
                        <FormGroup>
                            <FormLabel sx={{ fontSize: "22px" }} >Descripción</FormLabel>
                            <TextField 
                                multiline
                                rows={8}
                                placeholder='Escribe una descripción para la subcategoría'
                                sx={{ ...inputStyle }}
                                value={description}
                                onChange={onValueChange}
                                name="description"
                            />
                        </FormGroup>
                    </Box>

                    <Box sx={{width:'100%', display:'flex', justifyContent: 'space-between', gap: {xs: '1.14rem', md:'2.21rem', lg: '2.57rem'} }}>
                        <ButtonStyled text={'CANCELAR'} primary={false} customStyle={{ width:'100%' }} handleClick={onCloseNameNodal} isDisabled={isDisabled} />
                        <ButtonStyled text={'GUARDAR'} customStyle={{ width:'100%' }} handleClick={handleSubmit } isDisabled={isDisabled} />
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}

export default SubcategoryNameModal